import { createSvgIcon } from '@mui/material/utils'

const WarningForkKnife = createSvgIcon(
  <>
    <path
      d="M43.6501 8.93L22.9301 44.82H64.3701L43.6501 8.93Z"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M76.84 56.13V0.5C79.38 0.89 81.11 4.45 81.11 8.35V34.13H76.84"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M13.54 2.4L12.93 18.49L8.99999 22.21L9.36999 55.67H4.23999"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M0.5 2.4L1.11 18.49L5.04 22.21L4.24 55.67" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M9 2.4V15.47" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M5.04004 2.4V15.47" stroke="#204ECF" strokeLinejoin="round" />
    <path
      d="M42.262 33.886L42.454 28.126H41.326L41.518 33.886H42.262ZM41.89 36.25C42.25 36.25 42.55 35.938 42.55 35.59C42.55 35.23 42.25 34.93 41.89 34.93C41.53 34.93 41.23 35.23 41.23 35.59C41.23 35.938 41.53 36.25 41.89 36.25Z"
      fill="#204ECF"
    />
  </>,
  'WarningForkKnife'
)

export default WarningForkKnife
